
import React from 'react';

import { CiLocationOn } from "react-icons/ci";
import { IoMdWalk } from "react-icons/io";
import { IoCarOutline } from "react-icons/io5";

const NearbyCard = ({ type, name, address, distance, walk, drive, color }) => {
    
    return (
        <div className="flex flex-col gap-2 bg-[#F3F3F3] px-5 py-6 border-2 rounded-md">
            <span className="font-medium text-xs px-3 py-1 border rounded-md max-w-fit mb-2" style={{color: color, borderColor: color}}>{type}</span>
            <div className="flex flex-col">
                <span className="font-medium text-sm mb-1 line-clamp-1">{name}</span>
                <span className="font-light text-xs line-clamp-1">{address}</span>
            </div>
            <div id="distanceDiv" className="grid grid-cols-1 gap-1 border-t border-[#C5C5C5] pt-3 mt-1">
                <div className="flex items-center gap-1 justify-center">
                    <CiLocationOn size={16} className="text-gray-800" />
                    <span className="font-light text-xs">{distance} mi</span>
                </div>
                {/* <div className="flex items-center gap-1 justify-center">
                    <IoMdWalk size={16} className="text-gray-800" />
                    <span className="font-light text-xs">{walk}</span>
                </div>
                <div className="flex items-center gap-1 justify-center">
                    <IoCarOutline size={16} className="text-gray-950" />
                    <span className="font-light text-xs">{drive}</span>
                </div> */}
            </div>
        </div>
    );
}

export default NearbyCard;